import { AnimatePresence, motion, useAnimationFrame, useMotionValue } from "framer-motion";

export default function Button(props) {

    const text = props.text

    const repeatDelay = props.repeatDelay

    const onClick = props.onClick

    const small = props.small

    const border = props.border

    return (
        <motion.div className={"button"}
            animate={{
                rotate: [0, -2, 2, -2, 2, 0], // keyframes for wiggle
            }}
            
            transition={{
                rotate: {
                    duration: 0.6, // total duration of the wiggle
                    ease: "easeInOut",
                    repeat: Infinity, // repeat forever
                    repeatDelay: repeatDelay, // wait before next wiggle
                }
            }}
            whileTap={{
                scale: 0.96
            }}
            onClick={onClick}
        >
            {text}
        </motion.div>
    );
}